import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#000000"
					title={"Millards Bunbury"}
					// image={require('./video.jpg')}
					video={{ mp4: require('./video.mp4')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">Wanting to stay at the head of the industry.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/millard.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi worked closely to design an online presence both strengthening the brand and provide an easy to understand experience for their particulary target market.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Branding</li>
									<li>Digital Marketing Management</li>
									<li>Custom Designed Website <a href="https://www.millardmarine.com.au" target="_blank">www.millardmarine.com.au</a></li>
									<li>Advanced search capability</li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Magazine Design and Copywriting</li>
									<li>Print Advertisements</li>
									<li>Posters, Business Cards, Flyers etc</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Millard Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Millard Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Millard Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Millard Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/Millard/index.js